import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'trackingplacedata',
                () => import('./tracking-place-data/tracking-place-data.module').then(m => m.TrackingPlaceDataModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'region',
                () => import('./region/region.module').then(m => m.RegionModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'municipality',
                () => import('./municipality/municipality.module').then(m => m.MunicipalityModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
